import { render, staticRenderFns } from "./productAll.vue?vue&type=template&id=72dd55e9"
import script from "./productAll.vue?vue&type=script&lang=js"
export * from "./productAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports